import React from 'react'
import { useRef } from "react";
import { BasicTemplate } from './LandingPageThemes/BasicTemplate';
import Portfolio from './LandingPageThemes/Portfolio';
import { Shop } from './LandingPageThemes/Shop';


const LandingPagePreview = ({ pageData, inputData, colorTheme, setHtml, html }) => {

    const iframeRef = useRef(null);
    React.useEffect(() => {
        const splitHeader = inputData.main_headline.split(" ");
        const headlineStart = splitHeader.slice(0, -1).join(" ");
        const headlineEnd = splitHeader.slice(-1).join(" ");

        const generatedHtml = inputData.theme === "Simple" ? BasicTemplate({
            inputData,
            colorTheme,
            pageData,
            headlineStart,
            headlineEnd
        }) : inputData.theme === "Shop" ? Shop({
            inputData,
            colorTheme,
            pageData,
            headlineStart,
            headlineEnd
        }) : Portfolio({
            inputData,
            colorTheme,
            pageData,
            headlineStart,
            headlineEnd
        });
        setHtml(generatedHtml);
    }, [pageData, inputData, colorTheme, setHtml]);

    return (
        <div
            style={{
                border: "1px solid #ddd",
                overflow: "auto",
                height: "700px",
            }}
        >
            <iframe
                ref={iframeRef}
                title="Preview"
                style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                }}
                srcDoc={html}
            />
            <div className="mb-3"></div>
        </div>
    );
}

export default LandingPagePreview;